import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const NewRating = (props) => { 
    const item = props.item;
    return (
        <li className="turned">
            <div className="feed-icon">
                <svg className="icon icn-turnup">
                    <use xlinkHref="#icn-turnup" />
                </svg>
            </div>
            <Link to={`/${item.RoleUsername}`} className="thumbnail">
                <div className="userthumb">
                    <img src={props.getThumbnail(item.Thumbnail, item.RoleType)} alt="profile picture" />
                </div>
            </Link>
            <p className="type">TURNED UP! <span className="time">{item.DateText}</span></p>
            <div className="message">
                <p>{item.ResourceType.replace("Music", "Track")} '<Link to={`${item.ResourceType === 'Music' ? '/Track' : 'Video'}/${item.ResourceID}`}><strong>{item.ResourceName}</strong></Link>' by <Link to={`/${item.RoleUsername}`}><strong>{item.RoleDisplayName}</strong></Link> is getting louder!</p>
            </div>
        </li>

    );
};

NewRating.propTypes = {
    item: PropTypes.object.isRequired,
    getThumbnail: PropTypes.func.isRequired
};

export default NewRating;